import { Award, ExternalLink } from "lucide-react";

const marks = [
  { label: "CES 2027 Innovation Award Candidate" },
  { label: "9 US Patents" },
  { label: "Peer-Reviewed Clinical Study", href: "https://pmc.ncbi.nlm.nih.gov/articles/PMC13355733/" },
  { label: "ISO 13485 Partner Facility" },
  { label: "FDA-Registered Partner Facility" },
];

export const PressStrip = () => (
  <section aria-label="Recognition" className="relative border-y border-white/10">
    <div className="mx-auto max-w-[1400px] px-6 md:px-10 py-8 md:py-9">
      <div className="flex flex-col lg:flex-row lg:items-center gap-6 lg:gap-10">
        <div className="flex items-center gap-3 shrink-0">
          <Award className="w-4 h-4 text-primary" strokeWidth={1.5} />
          <span className="overline">Recognized &amp; validated</span>
        </div>
        <div className="flex flex-wrap items-center gap-x-8 gap-y-4 lg:gap-x-12">
          {marks.map((m) =>
            m.href ? (
              <a
                key={m.label}
                href={m.href}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="clinical-study-link"
                className="group inline-flex items-center gap-2 font-serif text-lg md:text-xl text-foreground/80 hover:text-primary transition-colors duration-300 whitespace-nowrap underline decoration-white/20 underline-offset-4 hover:decoration-primary"
              >
                {m.label}
                <ExternalLink className="w-3.5 h-3.5 opacity-60 group-hover:opacity-100 transition-opacity" strokeWidth={1.6} />
              </a>
            ) : (
              <span
                key={m.label}
                className="font-serif text-lg md:text-xl text-foreground/75 hover:text-foreground transition-colors duration-300 whitespace-nowrap"
              >
                {m.label}
              </span>
            )
          )}
        </div>
      </div>
    </div>
  </section>
);
